import { useEffect } from 'react';

import styles from './useDisableBodyScroll.module.scss';

export const useDisableBodyScroll = () => {
  useEffect(() => {
    document.body.classList.add(styles.disableScroll);

    return () => {
      document.body.classList.remove(styles.disableScroll);
    };
  }, []);
};
